import React, { useState } from 'react'

import InputComponent from 'components/Input'

import * as S from './styles'

const Getnet: React.FC = () => {
  const [marketAddress, setMarketAddress] = useState('')

  return (
    <S.Container>
      <S.Title>Configuração das credenciais</S.Title>

      <S.Col>
        <InputComponent
          id="authorization"
          name="authorization"
          label="Autorização"
          value={marketAddress}
          onChange={(e) => setMarketAddress(e.target.value)}
        />
      </S.Col>
    </S.Container>
  )
}

export default Getnet
